// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowUpLightSmall: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4" fill="currentColor">
            <polygon
                fill="#CCC"
                points="744 1380.8 743.125 1380 740.5 1382.4 737.875 1380 737 1380.8 740.5 1384"
                transform="matrix(1 0 0 -1 -737 1384)"
            />
        </svg>
    );
};

export default React.memo(IconArrowUpLightSmall);
